export const EMAIL_VALID_REGEX = /\S+@\S+\.\S+/;

export const successAddTeamMembersSettings = (
  inviteNumber: number
): { [key: string]: string } => ({
  title: 'Success',
  text: `You've just invited ${inviteNumber} team member${
    inviteNumber > 1 ? 's' : ''
  }`,
  type: 'success',
});

export const successAddLearnersSettings = (
  inviteNumber: number
): { [key: string]: string } => ({
  title: 'Success',
  text: `You've just invited ${inviteNumber} learner${
    inviteNumber > 1 ? 's' : ''
  }`,
  type: 'success',
});
